import React, { createContext } from "react";

interface ITabsContext {
  setActiveTabId: (tabId: string) => void;
  activeTabId: string;
}

export const TabsContext = createContext<ITabsContext>(null!);

export const useTabsContext = () => React.useContext(TabsContext);
